import { render, staticRenderFns } from "./Edit-departamento.vue?vue&type=template&id=04db1ba3&"
import script from "./Edit-departamento.vue?vue&type=script&lang=js&"
export * from "./Edit-departamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports